import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import selectors from '../../../store/shared/selectors'
import withTour from '../../../components/hocs/withTour'
import notificationsUtils from '../../../utils/notifications/notificationsUtils'
import BlankCard from '../../../components/ui/cards/BlankCard'
import CustomTable from '../../../components/ui/lists/CustomTable'
import PageTitle from '../../../components/ui/typography/PageTitle'
import InvitedPersonsWrapper from './components/InvitedPersonsWrapper'
import SignedUpPersonsWrapper from './components/SignedUpPersonsWrapper'
import StudentDetailsView from './components/StudentDetailsView/StudentDetailsView'
import StudentTasksCreateModal from './components/StudentTasksCreateModal'
import AssignTaskManager from './components/AssignTaskManager'
import * as adminActivitiesDuck from './adminActivitiesDuck'
import * as adminInvitationsDuck from './adminInvitationsDuck'
import * as adminSubordinatesDuck from './adminSubordinatesDuck'
import * as adminTasksDuck from './adminTasksAssignmentDuck'
import * as insTokenDuck from '../../unauthenticated/Onboarding/insTokenDuck'

class AuthenticatedAdminDashboardIndex extends Component {
  static propTypes = {
    adminStudentInvitationFormValues: PropTypes.any,
    currentUser: PropTypes.object,
    filteredAdminInvitations: PropTypes.array.isRequired,
    filteredStudentInvitations: PropTypes.array.isRequired,
    isLessThanMedium: PropTypes.bool,
    performInviteAdmin: PropTypes.func.isRequired,
    performInviteStudent: PropTypes.func.isRequired,
    performResendAdminInvite: PropTypes.func.isRequired,
    performResendStudentInvite: PropTypes.func.isRequired,
    performRetrieveActivities: PropTypes.func.isRequired,
    performRetrieveInvitations: PropTypes.func.isRequired,
    performRetrieveSubordinates: PropTypes.func.isRequired,
    performRetrieveTasks: PropTypes.func.isRequired,
    resetError: PropTypes.func,
    invitationError: PropTypes.any,
    studentSignups: PropTypes.array.isRequired,
    subadminSignups: PropTypes.array.isRequired,
    subAdminAllowed: PropTypes.bool,
    tokenOrganization: PropTypes.string,
    validateInsToken: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.onInviteAdmin = () =>
      this.props.performInviteAdmin({ admin_email: this.props.adminStudentInvitationFormValues.student_email })
        .then(() => {
          notificationsUtils.showSuccessNotification('Invitation Sent!')
        })
        .catch(() => {})

    this.onInviteStudent = () =>
      this.props
        .performInviteStudent(this.props.adminStudentInvitationFormValues)
        .then(() => {
          notificationsUtils.showSuccessNotification('Invitation Sent!')
        })
        .catch(() => {})

    this.onResendStudentInvite = invitationId =>
      this.props
        .performResendStudentInvite(invitationId)
        .then(() =>
          notificationsUtils.showSuccessNotification('Invitation Re-sent!'),
        )
        .catch(() => {})

    this.onResendAdminInvite = invitationId =>
      this.props.performResendAdminInvite(invitationId)
        .then(() => notificationsUtils.showSuccessNotification('Invitation Re-sent!'))
        .catch(() => {})
  }

  componentWillMount() {
    this.props.performRetrieveInvitations()
    this.props.performRetrieveSubordinates()
    this.props.performRetrieveActivities()
    this.props.performRetrieveTasks()
    if(!this.props.tokenOrganization) this.props.validateInsToken( this.props.currentUser )
  }

  render() {
    const {
      filteredAdminInvitations,
      filteredStudentInvitations,
      invitationError,
      studentSignups,
      isLessThanMedium,
      resetError,
      subadminSignups,
      subAdminAllowed,
      tokenOrganization,
    } = this.props

    return (
      <div>
        <div className="main-page">
          <PageTitle
            content={`${tokenOrganization || 'Admin'} Dashboard`}
            tourName="admin"
          />
          <div className="row" id="onboardingSummary">
            <div className="col-sm-6">
              <BlankCard delay={0.7}>
                <div>
                  <InvitedPersonsWrapper
                    error={invitationError}
                    resetError={resetError}
                    data={filteredStudentInvitations}
                    onInvitePerson={this.onInviteStudent}
                    onResendInvite={this.onResendStudentInvite}
                    title="Invited Students"
                    inviteTitle="Invite Student"
                  />
                </div>
              </BlankCard>
            </div>
            <div className="col-sm-6">
              <BlankCard delay={0.9}>
                <SignedUpPersonsWrapper
                  data={studentSignups}
                  title="Registered Students"
                />
              </BlankCard>
            </div>
          </div>
          <div id="studentDetails">
            <BlankCard delay={1.2} noPad={true}>
              <StudentDetailsView/>
            </BlankCard>
          </div>
          <div id="taskManager">
            <BlankCard
              delay={1.5}
              title="Task Manager"
            >
              <AssignTaskManager />
            </BlankCard>
          </div>
          { window.navigator.platform !== 'iPad' &&
            <div id="studentsTable">
              {!isLessThanMedium &&
              (<BlankCard
                delay={1.7}
                title="All Students"
              >
                {/*Data Stored in studentSignups which is being pulled from adminSubordinatesDuck*/}
                <CustomTable
                  columns={[
                    {
                      Header: 'Name',
                      accessor: 'profile.name',
                    },
                    {
                      Header: 'Email',
                      accessor: 'email',
                    },
                    {
                      Header: 'Last Log In',
                      id: 'lastLogin',
                      accessor: item => moment(item.lastLogin).fromNow(),
                    },
                  ]}
                  data={studentSignups}
                  noDataText='No Students found'
                />
              </BlankCard>)}
            </div>
          }
          { subAdminAllowed &&
            <div id="adminManagementZone" className="mt-5">
              <h5 className="text-danger mt-5">Admin Management Zone</h5>
              <hr />
              <div className="row">
                <div className="col-sm-6">
                  <BlankCard delay={0.7}>
                    <InvitedPersonsWrapper
                      error={invitationError}
                      resetError={resetError}
                      data={filteredAdminInvitations}
                      onInvitePerson={this.onInviteAdmin}
                      onResendInvite={this.onResendAdminInvite}
                      title="Invited Sub-Admins"
                      inviteTitle="Invite Sub-Admin"
                    />
                  </BlankCard>
                </div>
                <div className="col-sm-6">
                  <BlankCard delay={0.9}>
                    <SignedUpPersonsWrapper
                      data={subadminSignups}
                      title="Registered Sub-Admins"
                    />
                  </BlankCard>
                </div>
              </div>
            </div>
          }
        </div>
        <StudentTasksCreateModal studentSignups={studentSignups} />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getCurrentUser = selectors.makeGetCurrentUser()
  return state => ({
    adminStudentInvitationFormValues: selectors.getReduxFormValues(
      state.form.adminStudentInvitationForm,
    ),
    currentUser: getCurrentUser(state),
    filteredAdminInvitations: adminInvitationsDuck.getFilteredAdminInvitations(state),
    filteredStudentInvitations: adminInvitationsDuck.getFilteredStudentInvitations(
      state,
    ),
    invitationError: adminInvitationsDuck.getError(state),
    studentSignups: adminSubordinatesDuck.getSubordinateStudents(state),
    subadminSignups: adminSubordinatesDuck.getSubordinateAdmins(state),
    subAdminAllowed: selectors.getSubAdminAllowed(state),
    isLessThanMedium: selectors.isLessThanMedium(state),
    tokenOrganization: insTokenDuck.getName(state),
  })
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      performInviteStudent: adminInvitationsDuck.performInviteStudent,
      performResendStudentInvite:
        adminInvitationsDuck.performResendStudentInvite,
      performRetrieveActivities: adminActivitiesDuck.performRetrieveActivities,
      performRetrieveInvitations:
        adminInvitationsDuck.performRetrieveInvitations,
      performRetrieveSubordinates:
        adminSubordinatesDuck.performRetrieveSubordinates,
      performInviteAdmin: adminInvitationsDuck.performInviteAdmin,
      performResendAdminInvite: adminInvitationsDuck.performResendAdminInvite,
      performRetrieveTasks: adminTasksDuck.performRetrieveTasks,
      resetError: adminInvitationsDuck.resetAdminInviteError,
      validateInsToken: insTokenDuck.performValidateInsToken,
    },
    dispatch,
  )

// Tour Steps
const tourSteps = [
  {
    selector: '#onboardingSummary',
    content: "View invites and sign ups or, invite new students by clicking the blue button.",
  },
  {
    selector: '#studentDetails',
    content: "Click a student on the left to view more. Here, an example student has is shown.",
  },
  {
    selector: '#taskManager',
    content: 'Make sure your students are getting the most out of Steppingblocks by assigning tasks here.',
  },
  {
    selector: '#tasksCompleted',
    content: "We'll track your student's progress automatically, and show their progress here"
  },
  {
    selector: '#studentsTable',
    content: "Find basic information about your students in this table."
  },
  {
    selector: '#adminManagementZone',
    content: "Add other administrators to your organization here."
  }
]

export default connect(makeMapStateToProps, mapDispatchToProps)(
  withTour('admin', tourSteps)(AuthenticatedAdminDashboardIndex),
)



// WEBPACK FOOTER //
// ./src/routes/authenticated/AdminDashboard/AuthenticatedAdminDashboardIndex.js